
import PaymentSummaryCard from "../../common/PaymentSummaryCard";

export default function InfoSection({ payment }) {
	return (
		<section aria-label="خلاصه پرداخت">
			<PaymentSummaryCard payment={payment} />
			{payment.id != null && (
				<p className="mt-3 text-center font-Vazir-400 text-[12px] text-darkBlue/45">
					شناسه تراکنش:{" "}
					<span className="font-Vazir-500 text-darkBlue/70" dir="ltr">
						#{payment.id}
					</span>
				</p>
			)}
		</section>
	);
}
